import { Component } from '@angular/core';
import System from 'framework/System';
import BaseComponent from '../BaseComponent';
import { PriorityViewModel } from 'app/models/PriorityViewModel';
import TicketTypes = Boo.Objects.Enums.TicketTypeEnum;
import IValidatedResult = app.interfaces.IValidatedResult;
import { SaveTypes } from 'app/models/enums/SaveTypes';
import Utils from '../../../shared/utils';
import { StoreService } from '../../../services/store.service';
import { ReloadService } from '../../../services/reload.service';
import { FormControl, Validators } from '@angular/forms';
import { CustomerService } from '../../../services/customer.service';

@Component({
  selector: 'app-components-ticket-review',
  templateUrl: './Review.component.html'
})
export class ReviewComponent extends BaseComponent {
  utils = Utils;
  ko = ko;
  isEnabled: boolean;
  customerInformationControlParent: Record<string, any>;
  customerUser: CustomerUserObservable;
  customerSpendSummaries: KnockoutObservableArray<CustomerSpendSummaryObservable>;
  canResetWebsite: boolean;
  ordersSnapshot: Boo.ApisExternal.Store.Objects.Order[];
  verticals: Boo.Objects.Vertical[];
  isOpen = false;
  verticalCtrl: FormControl<number>;

  private websiteResetTicketTypes: TicketTypes[] = [TicketTypes.SeoOnboarding, TicketTypes.SeoOnboardingWorkblock];

  constructor(
    private storeService: StoreService,
    private customerService: CustomerService,
    private reloadService: ReloadService) {
    super();
  }

  public activate(params: app.ticket.components.interfaces.ITicketComponentActivateParams): JQueryPromise<void> {
    return super.activate(params)
      .then(() => {
        this.canResetWebsite = this.websiteResetTicketTypes.indexOf(params.ticket.TicketType.TicketTypeId()) > -1
          && params.partner.PartnerId === Boo.Objects.Enums.PartnerEnum.Boostability
          && (params.ticket.StatusId() === Boo.Objects.Enums.TaskStatusEnum.Pending
            || params.ticket.StatusId() === Boo.Objects.Enums.TaskStatusEnum.Locked);
        this.triggerTicketSave = params.triggerTicketSave;
        this.customerSpendSummaries = params.customer.Spends;
        this.isEnabled = params.canEdit;
        if (!this.isEnabled) {
          return;
        }

        this.customerUser = this.customer.Users().find((x: CustomerUserObservable) => x.EmailRecipientType() == Boo.Objects.Enums.EmailRecipientTypes.To && x.CanContact()) ?? this.customer.Users().find((x: CustomerUserObservable) => x.CanContact());
        this.customerInformationControlParent = {
          customer: ko.observable(this.customer),
          customerUser: this.customerUser ? ko.observable(this.customerUser) : undefined,
          partner: ko.observable(ko.toJS(this.customer.Partner))
        };
        const existingVertical = this.customer.VerticalId() ? this.customer.VerticalId() : null;
        this.verticalCtrl = new FormControl<number>(existingVertical, Validators.required);

        return Utils.wrapDfd(this.storeService.getOrdersSnapshot(params.customer.CustomerId()));
      })
      .then((snapshot) => {
        this.ordersSnapshot = snapshot;
      });
  }

  /**
   * Callback for customer priority views to notify us they've saved the customer
   */
  public customerSavedCallback(): void {
    this.modifiedDataFlags.customer = true;
  }

  public resetCustomerWebsite(): void {
    this.triggerTicketSave(SaveTypes.UpdateWithoutTicketNoteValidation, false)
      .then(() => {
        PriorityViewModel.show('app-components-customerservice-managertools', {
          'customerId': this.customer.CustomerId()
        }).done((data: any) => {
          if (data && data.url) {
            this.customer.Url(data.url);
          }
          this.customerSavedCallback();
          this.reloadService.reload();
        });
      });
  }

  public save(saveType: SaveTypes): JQueryPromise<app.ticket.interfaces.ISaveData> {
    return super.save(saveType)
      .then(() => {
        return {
          customer: {
            VerticalId: this.verticalCtrl.value
          }
        };
      });
  }

  public validate(saveType: SaveTypes): JQueryPromise<IValidatedResult> {
    return super.validate(saveType)
      .then((validationResult) => {
        Utils.showAllMessages(this.verticalCtrl);
        if (saveType === SaveTypes.Complete && !this.verticalCtrl.valid) {
          this.isOpen = false;
          validationResult.isValid = false;
          return System.resolvedPromise<IValidatedResult>({ isValid: false, errorMessages: ['Vertical is required'] });
        }
        return validationResult;
      });
  }
}
